function normalizeError(err) {
    if (err instanceof Error) return err;

    try {
        const text = typeof err === 'string'
            ? err
            : JSON.stringify(err, Object.getOwnPropertyNames(err) ?? Object.keys(err));
        return new Error(text);
    } catch {
        return new Error(String(err));
    }
}

function isFromExtension(stackOrUrl = '') {
    return typeof stackOrUrl === 'string' &&
        (stackOrUrl.startsWith('chrome-extension://') ||
            /extensions\//i.test(stackOrUrl) ||
            stackOrUrl.startsWith('moz-extension://') ||
            stackOrUrl.startsWith('safari-web-extension://'));
}

window.addEventListener('error', (e) => {
    const url = e.filename || (e.error && e.error.fileName) || '';
    if (isFromExtension(url)) return;

    const err = normalizeError(e.error || e.message || e);
    console.error('[global-error]', err);
});

window.addEventListener('unhandledrejection', (e) => {
    const stack = (e.reason && e.reason.stack) || String(e.reason || '');
    if (isFromExtension(stack)) return;

    const err = normalizeError(e.reason);
    console.error('[unhandled-rejection]', err);
});

